import React from 'react';
import moment from 'moment';
import { MDBIcon } from 'mdb-react-ui-kit';
import Helper from '../../../Helper';


const PrintFooter = ({ company, header, transportAccount, customer, userinfo }) => {
    const selectedBank = Helper.bank.find(el => el.value === company?.bankname);

    return (
        <div className="print-footer-container">
            <div className="print-footer" >

                <table className='footer-table mt-1'>
                    <tbody>
                        <tr>
                            <th style={{ width: "12%" }}><MDBIcon fas icon="clipboard-list me-1" />สรุป</th>
                            {parseFloat(transportAccount.totalvatamount) == 0 ? <> <th style={{ width: "22%" }}>มูลค่าไม่มีหรือยกเว้นภาษี</th>
                                <td style={{ width: "25%", textAlign: "right" }}>{Helper.formatnumber(transportAccount.totalnetamount)} บาท</td>
                            </> :
                                <> <th style={{ width: "22%" }}>ภาษีมูลค่าเพิ่ม 7%</th>
                                    <td style={{ width: "25%", textAlign: "right" }}>{Helper.formatnumber(transportAccount.totalvatamount)} บาท</td>
                                </>}<td style={{ width: "1%" }}></td>
                            <td style={{ width: "40%", backgroundColor: '#eee' }} className='p-2' rowSpan={2} colSpan={2}>
                                <table >
                                    <tbody>
                                        <tr >
                                            <th style={{ width: "40%", verticalAlign: "baseline" }}>จำนวนเงินทั้งสิ้น</th>
                                            <th style={{ width: "60%", textAlign: "right", verticalAlign: "baseline", textAlign: "right" }}><span style={{ zoom: "140%" }}>{Helper.formatnumber(transportAccount.totalnetamount)}</span>  บาท</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <th style={{ verticalAlign: "top"}}>จำนวนเงินทั้งสิ้น</th>
                            <td style={{ textAlign: "right" }}>{(Helper.BAHTTEXT(transportAccount.totalnetamount))}</td>
                        </tr>
                        <tr>
                            <td colSpan={4} ></td>
                            <th>จำนวนเงินที่ถูกหัก ณ ที่จ่าย</th>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(transportAccount.totalwhtamount)} บาท</td>
                        </tr>
                        <tr>
                            <td colSpan={4} ></td>
                            <th>จำนวนเงินที่ชำระ</th>
                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(transportAccount.totalpaidamount)} บาท</td>
                        </tr>

                        <tr><td colSpan={6} style={{ borderTop: '1px solid #ccc' }} className='mt-2 mb-2'></td></tr>
                        <tr>
                            <th style={{ verticalAlign: "top" }}><MDBIcon fas icon="money-bill" className="me-1" />ชำระเงิน</th>

                            <td colSpan={5}>
                                <table  >
                                    <tbody>
                                        <tr >
                                            <td>วันที่ชำระ:</td>
                                            <td className='pe-2' style={{ textAlign: "right" }}>{moment(transportAccount.receipt_dateobj).format("DD/MM/YYYY")}</td>
                                            <td className='pt-1' rowSpan={3} style={{ width: "40px", verticalAlign: "top" }}><img src={`/bank-logo/${selectedBank.value.toLowerCase()}.png`}
                                                style={{ width: "30px" }} />
                                            </td>
                                            <td>{selectedBank.text}
                                            </td>
                                            <td style={{ textAlign: "right" }}>{transportAccount.totalpaidamount} บาท</td>
                                        </tr>
                                        <tr >
                                            <td>จำนวนเงินรวม:</td>
                                            <td  className='pe-2' style={{ textAlign: "right" }}>{transportAccount.totalpaidamount} บาท</td>

                                            <td colSpan={2}>
                                                <b>{company.bankaccounttype + ' ' + company.bankaccount}</b>
                                                <div>{company.bankaccountname}</div>
                                            </td>
                                        </tr>
                                        <tr >
                                            <td colSpan={3}></td>
                                            <td>ภาษีหัก ณ ที่จ่าย  <b>{transportAccount.receiptname}</b></td>
                                            <td style={{ textAlign: "right" }}>{transportAccount.totalwhtamount} บาท</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr><td colSpan={6} style={{ borderTop: '1px solid #ccc' }} className='mt-2 mb-2'></td></tr>
                        <tr>
                            <th style={{ verticalAlign: "top" }}><MDBIcon fas icon="comment-dots" className="me-1" />หมายเหตุ</th>
                            <td colSpan={4}><div style={{ whiteSpace: "pre-wrap" }}>{transportAccount.remark}</div></td>

                        </tr>
                        <tr><td colSpan={6} style={{ borderTop: '1px solid #ccc' }} className='mt-2 mb-2'></td></tr>

                        <tr>
                            <th style={{ verticalAlign: "top" }}><MDBIcon fas icon="signature" className="me-1" />รับรอง</th>
                            <td colSpan={5}>
                                <table  >
                                    <tbody>
                                        <tr>
                                            <th style={{ textAlign: "center" }}>ผู้ออกเอกสาร (ผู้ขาย)</th>
                                            <th style={{ textAlign: "center" }}>ผู้อนุมัติเอกสาร (ผู้ขาย)</th>
                                            <th style={{ textAlign: "center" }}>ตราประทับ (ผู้ขาย)</th>
                                            <th style={{ textAlign: "center" }}>ผู้รับเอกสาร (ลูกค้า)</th>
                                        </tr>
                                        <tr >
                                            <td style={{ width: "25%" }}><div style={{ height: "50px" }}></div></td>
                                            <td style={{ width: "25%" }}><div style={{ height: "50px" }}></div></td>
                                            <td style={{ width: "25%" , textAlign: "center"  }} rowSpan={2}><div><img src="/stamp.png" alt="Company Stamp" style={{ width: 'auto', height: '100px' }} /></div></td>
                                            <td style={{ width: "25%" }}><div style={{ height: "50px" }}></div></td>

                                        </tr>
                                        <tr>
                                            <th style={{ textAlign: "center" }}>{userinfo.name}</th>
                                            <th style={{ textAlign: "center" }}>{userinfo.name}</th>

                                            <th rowSpan={2} style={{ verticalAlign: "top", textAlign: "center" }}>{customer.name}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: "center" }}>{moment(transportAccount.billdateobj).format("DD/MM/YYYY")}</td>
                                            <td style={{ textAlign: "center" }}>{moment(transportAccount.billdateobj).format("DD/MM/YYYY")}</td>
                                            <td></td>

                                        </tr>
                                    </tbody>
                                </table>

                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default PrintFooter;